import { useMemo } from 'react'
import { sumAmount } from 'utils/orderbook'
import { combineOrderbook } from 'utils/orderbook/combine'
import {
  MAXIMUM_SINGLE_SIDE_VIEW,
  MOBILE_DISPLAY_ROW,
  PC_DISPLAY_ROW,
} from '../../constants/orderbook'
import {
  useOrderbook,
  useOrderbookPrecision,
  useShowListType,
} from 'store/orderbook/hooks'
import { OrderbookDataItem } from 'store/orderbook/types'
import { isMobile } from 'utils/userAgent'

export function useOrderbookList(row: number = PC_DISPLAY_ROW) {
  const orderbook = useOrderbook()
  const precision = useOrderbookPrecision()
  const showListType = useShowListType()

  // If the user chooses to single-sided display, the number of rows displayed is fixed
  let showListNum = showListType !== 0 ? MAXIMUM_SINGLE_SIDE_VIEW : row

  if (isMobile) {
    showListNum = MOBILE_DISPLAY_ROW
  }

  const currentBidsList: OrderbookDataItem[] = useMemo(() => {
    if (!orderbook?.buyOrders || !orderbook.buyOrders?.length) {
      return []
    }

    const sumAll = sumAmount(orderbook.buyOrders)
    let sum = 0
    return combineOrderbook(orderbook.buyOrders, precision)
      .map((v) => {
        sum += Number(v.amount)
        return {
          ...v,
          percent: (sum / Number(sumAll)) * 100,
        }
      })
      .slice(0, showListNum)
  }, [precision, orderbook, showListNum])

  const currentAsksList: OrderbookDataItem[] = useMemo(() => {
    if (!orderbook?.sellOrders || !orderbook.sellOrders?.length) {
      return []
    }

    const sumAll = sumAmount(orderbook.sellOrders)
    let sum = 0
    return combineOrderbook(orderbook.sellOrders, precision)
      .map((v) => {
        sum += Number(v.amount)
        return {
          ...v,
          percent: (sum / Number(sumAll)) * 100,
        }
      })
      .slice(0, showListNum)
      .reverse()
  }, [precision, orderbook, showListNum])

  if (!orderbook?.symbol) {
    return null
  }

  return {
    currentBuyOrders: currentBidsList,
    currentSellOrders: currentAsksList,
  }
}
